import React from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogFooter, TextField, Button, Flex } from '@chatsdet/ui';
type VersionNameDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  initialName?: string;
  onSubmit: (name: string | null) => void;
  isPending?: boolean;
};

export function VersionNameDialog({
  isOpen,
  onOpenChange,
  title,
  initialName = '',
  onSubmit,
  isPending = false,
}: VersionNameDialogProps) {
  const [name, setName] = React.useState(initialName);

  React.useEffect(() => {
    if (isOpen) setName(initialName);
  }, [isOpen, initialName]);

  const handleSubmit = () => {
    onSubmit(name.trim() || null);
    onOpenChange(false);
  };

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
      <span />
      <Dialog title={title}>
        <DialogContent>
          <Flex direction="column" gap="md">
            <TextField
              label="Version name"
              placeholder="e.g., Before refactor, Login fix"
              value={name}
              onChange={setName}
              isDisabled={isPending}
              autoFocus
            />
          </Flex>
        </DialogContent>
        <DialogFooter>
          <Button variant="outline" onPress={() => onOpenChange(false)} isDisabled={isPending}>
            Cancel
          </Button>
          <Button variant="primary" onPress={handleSubmit} isDisabled={isPending}>
            Save
          </Button>
        </DialogFooter>
      </Dialog>
    </DialogTrigger>
  );
}
